/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_ButtonInputs */

const en_directory_submit_button = /** @type {(inputs: Directory_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit tool`)
};

const zh_directory_submit_button = /** @type {(inputs: Directory_Submit_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交工具`)
};

/**
* | output |
* | --- |
* | "Submit tool" |
*
* @param {Directory_Submit_ButtonInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_button = /** @type {((inputs?: Directory_Submit_ButtonInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_ButtonInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_button(inputs)
	return zh_directory_submit_button(inputs)
});
export { directory_submit_button as "directory.submit.button" }